export default {
  account_name: 'Account Name',
  archive: {
    button: {
      reactivate: 'Reactivate',
    },
  },
  external: {
    'tab-label': 'External Account',
    button: {
      'reset-account': 'Reset',
      'sync-password': 'Sync Password',
    },
    modal: {
      'delete-account': {
        title: 'Delete account',
        confirm: 'Confirm',
        cancel: 'Cancel',
        message: 'You are about to delete account #{loginid}. Continue?',
      },
      'sync-password': {
        title: 'Sync Password',
        confirm: 'Confirm',
        cancel: 'Cancel',
        'email-verify-code-label': 'Security verification',
        form: {
          'new-password': {
            label: 'New password',
            placeholder: 'Please input new password',
          },
          'email-verify-code': {
            label: 'Security verification',
            placeholder: 'Please input verify code',
          },
          validation: {
            'please-input-new-password': 'Please input new password',
            'please-input-verify-code': 'Please input verify code',
          },
        },
      },
      'rename-external-account': {
        title: 'Rename External Account',
        confirm: 'Confirm',
        cancel: 'Cancel',
        form: {
          name: {
            label: 'Account Nickname',
            placeholder: 'Please input account nickname',
          },
          validation: {
            'please-input-account-nickname': 'Please input account nickname',
          },
        },
      },
      title: 'Reset Account',
      confirm: 'Confirm',
      cancel: 'Cancel',
    },
    form: {
      'node-id': {
        label: 'Assign Server',
        placeholder: 'Please select server',
      },
    },
  },
  sort: {
    newest: 'Newest',
    oldest: 'Oldest',
    balance_desc: 'Balance High → Low',
    balance_asc: 'Balance Low → High',
    name_asc: 'Name A-Z',
    name_desc: 'Name Z-A',
    create_time: 'Create Time',
  },
  'my-account': 'My Account',
  'bind-external-account': 'Bind External Account',
  'create-account': 'Create Account',
  // 账户类型（普通/保险/社交信号员/PAMM信号员）
  type: {
    gtcSignal: 'Smart Follow Signal',
    pamm: 'PAMM',
    signal: 'Standard MT Signal',
    follow: 'follow account',
    standard: 'standard account',
  },
  // 账户分类（真实/模拟/已归档）
  category: {
    live: 'Live',
    demo: 'Demo',
    archived: 'Archived',
  },
  // AccountCard 组件专用字段
  balance: 'Balance',
  'margin-free': 'Free Margin',
  equity: 'Equity',
  leverage: 'Leverage',
  credit: 'Credit',
  'deposit-button-text': 'Deposit',
  'withdraw-button-text': 'Withdraw',
  'trade-button-text': 'Trade',
  tabs: {
    live: 'Real',
    demo: 'Demo',
    archived: 'Archived',
    external: 'External Account',
  },
  select: {
    newest: 'Newest',
    oldest: 'Oldest',
    'free-margin': 'Free margin',
    nickname: 'Nickname',
  },
  'transfer-funds': 'Transfer',
  doWithdraw: 'Withdraw',
  'change-max-leverage': 'Leverage application',
  'rename-account': 'Change account nickname',
  'account-information': 'Account information',
  'set-read-only-access': 'Set read-only password',
  'manage-your-statements': 'Manage your statements',
  'change-trading-password': 'Change trading password',
  'archive-account': 'Archive account',
  'delete-external-account': 'Delete account',
  'rename-external-account': 'Change account nickname',
  margin: 'Margin',
  'leverage-value': '1:{LEVERAGE} (Max 1:{MAX_LEVERAGE})',
  'available-margin': 'Available margin',
  'unrealized-pnl': 'Unrealized P&L',
  'net-worth': 'Net worth',
  platform: 'Platform',
  trade: 'Trade',
  'verify-account-information-for-secure-operations':
    'Verify account information for secure operations',
  'leverage-modal-account': 'Account: #{loginid}',
  'current-account-name': 'Current account name',
  'new-account-name': 'New account name',
  'crename-account-description':
    'You are about to rename account #{loginid}. Please provide a new account name below.',
  'please-input-account-name': 'Please input account name',
  'set-read-only-access-title': 'Set read-only password',
  'account-label': 'Account: #{loginid}',
  'set-read-only-access-description':
    'You can share read-only access to your trading account to show your performance to investors.',
  'set-password-label': 'New read-only password',
  'please-input-readonly-password': 'Please input read-only access password',
  'manage-your-statements-description': 'Account: #{loginid}',
  'send-me-statements-to': 'Send me statements to {email}',
  'enter-the-current-account-password': 'Enter the current account password',
  'new-account-password': 'New account password',
  'confirm-password': 'Confirm password',
  'please-input-current-account-password': 'Please input current account password',
  'please-input-new-password': 'Please input new password',
  'please-input-confirm-password': 'Please input confirm password',
  'confirm-archive-message': 'You are about to archive account #{loginid}. Continue?',
  'cancel-archive-account': 'Cancel',
  'confirm-archive-account': 'Yes, archive account',
  'password-mismatch': 'Password mismatch',
  'platform-account': 'Platform account',
  'account-infomation': 'Account information',
  'account-id': 'Account ID',
  'account-type': 'Account type',
  'current-leverage': 'Current leverage',
  'max-leverage': 'Max leverage',
  'free-margin': 'Free margin',
  'unrealized-pl': 'Unrealized P&L',
  server: 'Server',
  // RenameAccountModal 专用字段
  'current-account': 'Current Account',
  'account-nickname': 'Account Nickname',
  modal: {
    leverage: {
      title: 'Change max leverage',
      leverage: 'Change leverage',
      'email-verify-code-label': 'Security verification',
    },
    tradingPassword: {
      title: 'Change trading password',
      confirm: 'Confirm',
      cancel: 'Cancel',
      'email-verify-code-label': 'Security verification',
      validation: {
        pleaseInputNewPassword: 'Please input new password',
        pleaseInputVerifyCode: 'Please input verify code',
      },
    },
    'set-read-only-access': {
      title: 'Set read-only password',
      confirm: 'Confirm',
      cancel: 'Cancel',
      'email-verify-code-label': 'Security verification',
      validation: {
        pleaseInputNewPassword: 'Please input new password',
        pleaseInputVerifyCode: 'Please input verify code',
      },
    },
    'create-account': {
      header: {
        tabs: {
          internal: 'Create internal account',
          external: 'Bind external account',
        },
      },
      title: 'Create account',
      confirm: 'Confirm',
      cancel: 'Cancel',
      'email-verify-code-label': 'Security verification',
      validation: {
        pleaseInputAccountName: 'Please input account name',
        pleaseInputVerifyCode: 'Please input verify code',
      },
      form: {
        internal: {
          label: {
            nickname: 'Nickname',
            server_id: 'Platform',
            applytype: 'Account type',
            leverage: 'Leverage',
            account_currency: 'Account currency',
          },
          placeholder: {
            nickname: 'Please input account nickname',
            server_id: 'Please select platform',
            applytype: 'Please select account type',
            leverage: 'Please select leverage',
            account_currency: 'Please select currency',
          },
          validation: {
            nickname: {
              maxlength: 'Nickname cannot exceed 20 characters',
              noEmoji: 'Emoji characters are not supported',
            },
          },
        },
        external: {
          label: {
            nickname: 'Nickname',
            exchange_name: 'Exchange name',
            loginid: 'MT login ID',
            password: 'MT password',
          },
          placeholder: {
            nickname: 'Please input account nickname',
            exchange_name: 'Please select exchange name',
            loginid: 'Please input MT login ID',
            password: 'Please input MT password',
          },
          validation: {
            nickname: {
              maxlength: 'Nickname cannot exceed 20 characters',
              noEmoji: 'Emoji characters are not supported',
            },
          },
        },
      },
    },
    RenameAccountModal: {
      title: 'Rename account',
      confirm: 'Confirm',
      cancel: 'Cancel',
      form: {
        name: {
          label: 'Account nickname',
          placeholder: 'Please input account nickname',
        },
      },
      validation: {
        noEmoji: 'Emoji characters are not supported',
      },
    },
  },
}
